import React, { Component } from "react";

class FinishProductInquiry extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                Finish Product Inquiry
            </div>
        );
    }
}

export default FinishProductInquiry;
